import { Link } from "react-router-dom"
import SkillCard from "../components/SkillCard"
import ProjectCard from "../components/ProjectCard"
import "./Home.css"

const Home = () => {
  const skills = [
    {
      icon: "fas fa-code",
      title: "Frontend Development",
      description: "Creating responsive and interactive user interfaces using React and other modern frameworks.",
    },
    {
      icon: "fas fa-server",
      title: "Backend Development",
      description: "Building robust server-side applications with Node.js, Spring Boot, and database integration.",
    },
    {
      icon: "fas fa-mobile-alt",
      title: "Mobile Development",
      description: "Developing cross-platform mobile applications using Flutter and other technologies.",
    },
    {
      icon: "fas fa-database",
      title: "Database Management",
      description: "Working with SQL and NoSQL databases like MongoDB to store and manage application data.",
    },
  ]

  const featuredProjects = [
    {
      title: "We Neighbour",
      description:
        "A mobile app for resource sharing in apartments. Users can share, borrow, and manage resources within their apartment community.",
      image: "/images/we-neighbour.jpg",
      technologies: ["Flutter", "Node.js", "MongoDB"],
      link: "https://www.weneighbour.live",
    },
    {
      title: "Real-Time Event Ticketing System",
      description: "A real-time event booking system with live seat selection and instant confirmation features.",
      image: "/images/event-ticketing.jpg",
      technologies: ["React", "Spring Boot", "WebSocket"],
      link: "https://ticketing-eight-tau.vercel.app",
    },
    {
      title: "Real-Time Bookstore Management System",
  description: "A dynamic bookstore application with real-time stock updates, live order tracking, and seamless author, book, and customer management.",
  image: "/images/bookstore.jpg",
  technologies: ["React","JAX-RS"],
  link: "https://book-store-ten-psi.vercel.app/"
    }
  ]

  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          <h1>Hi, I'm Chamuditha Nonis</h1>
          <h2>Computer Science Student & Developer</h2>
          <p>I build innovative web and mobile applications with modern technologies.</p>
          <div className="hero-buttons">
            <Link to="/projects" className="btn">
              View My Work
            </Link>
            <Link to="/contact" className="btn btn-outline">
              Contact Me
            </Link>
          </div>
        </div>
        <div className="hero-image">
          <div className="image-container">
            {/* Replace with your actual image */}
            <img src="/images/about.jpg" alt="Chamuditha Nonis" />
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="section about-section">
        <div className="container">
          <h2 className="section-title">About Me</h2>
          <div className="about-content">
            <p>
              I'm a second-year Computer Science student passionate about creating innovative solutions to real-world
              problems. With experience in web and mobile development, I enjoy building applications that are both
              functional and user-friendly.
            </p>
            <p>
              My journey in programming began with web development, and I've since expanded my skills to include mobile
              app development, backend systems, and database management.
            </p>
            <div className="about-cta">
              <Link to="/about" className="btn">
                Learn More About Me
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Skills Section */}
      <section className="section skills-section">
        <div className="container">
          <h2 className="section-title">My Skills</h2>
          <div className="skills-grid">
            {skills.map((skill, index) => (
              <SkillCard key={index} icon={skill.icon} title={skill.title} description={skill.description} />
            ))}
          </div>
        </div>
      </section>

      {/* Featured Projects Section */}
      <section className="section projects-section">
        <div className="container">
          <h2 className="section-title">Featured Projects</h2>
          <div className="projects-grid">
            {featuredProjects.map((project, index) => (
              <ProjectCard key={index} project={project} />
            ))}
          </div>
          <div className="projects-cta">
            <Link to="/projects" className="btn">
              View All Projects
            </Link>
          </div>
        </div>
      </section>

      {/* Contact CTA Section */}
      <section className="section contact-cta-section">
        <div className="container">
          <div className="contact-cta">
            <h2>Interested in working together?</h2>
            <p>Feel free to reach out if you're looking for a developer, have a question, or just want to connect.</p>
            <Link to="/contact" className="btn">
              Get In Touch
            </Link>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Home

